/**
 * Filter array to remove null or undefined values
 */
export const truthy = <TValue>(
  value: TValue | null | undefined,
): value is TValue => {
  return value !== null && value !== undefined;
};
